export const CATEGORIES = ['All', 'Electronics', 'Fashion', 'Home', 'Kitchen']

export const SORT_OPTIONS = [
  { value: 'trending',   label: '🔥 Trending'        },
  { value: 'discount',   label: '💸 Highest Discount' },
  { value: 'price_low',  label: '💰 Lowest Price'     },
  { value: 'price_high', label: '📈 Highest Price'    },
]

export const PLATFORM_STYLES = {
  Amazon:  { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200', dot: 'bg-orange-500' },
  Flipkart:{ bg: 'bg-blue-50',   text: 'text-blue-700',   border: 'border-blue-200',   dot: 'bg-blue-500'   },
  Myntra:  { bg: 'bg-pink-50',   text: 'text-pink-700',   border: 'border-pink-200',   dot: 'bg-pink-500'   },
  IKEA:    { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-200', dot: 'bg-yellow-500' },
  'H&M':   { bg: 'bg-red-50',    text: 'text-red-700',    border: 'border-red-200',    dot: 'bg-red-500'    },
}

export const DEFAULT_PLATFORM_STYLE = {
  bg: 'bg-slate-50', text: 'text-slate-700', border: 'border-slate-200', dot: 'bg-slate-500',
}

export const DEALS_PER_PAGE = 8
export const LOAD_MORE_COUNT = 4
